<script setup>
    import { computed } from "vue";

    const props = defineProps({
        vimeo: String, 
        youtube: String,
    });

    const video = computed(() => {
        if (props.vimeo) {
            return 'https://player.vimeo.com/video/' + props.vimeo + '?h=4adbaa86bc&byline=0&portrait=0';
        }

        if (props.youtube) {
            return 'https://www.youtube.com/embed/' + props.youtube;
        }
    });
</script>

<template>
    <div v-if="props.vimeo" style="padding:56.25% 0 0 0;position:relative;">
        <iframe :src="video" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
    </div>

    <div v-if="props.youtube" style="aspect-ratio: 16 / 9;">
        <iframe width="100%" height="100%" :src="video" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>

    <div v-if="!props.vimeo && !props.youtube">
        <p>Mettre le code Vimeo ou Youtube pour cette vidéo dans le Maestro.</p>
    </div>
</template>